import { filter, get } from 'lodash';

import { connectWithStore } from '@common/connectWithStore';
import { getFeatures } from '@react/Pages/AccountSettingsPage/PricingPlanPage/features';
import {
  getAttributions,
  getAttributionPrice,
  getBasePrice,
} from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPlan/formatters';
import { defaultContractLength } from '@redux/ducks/global';
import { hideForm, submitToBeInTouch, confirm, getState } from '@redux/ducks/account/pricingPlan/changePricingPlan';
import { getState as getPricingPlans } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { allowUpgradePlan, getChangeType } from '@redux/ducks/account/pricingPlan/pricingPlans.utils';
import { PlanPeriod } from '@redux/ducks/account/pricingPlan/interfaces';
import { ChangePricingPlanForm } from './ChangePricingPlanForm';

const mapStateToProps = state => {
  const { isContacted, plan } = getState(state);
  const { currentPlan, planPeriod } = getPricingPlans(state);

  if (!plan) {
    return null;
  }

  const isPlanChangeUpgrade = allowUpgradePlan(plan, currentPlan);
  const isFeatureEnabled = !!(isPlanChangeUpgrade && currentPlan);

  const enabledFeatures = filter(
    getFeatures(t),
    feature => get(plan, `features.${feature.key}.enabled`, false) === isFeatureEnabled,
  );

  const isYearlyButNotCurrent = currentPlan ? !currentPlan.yearly && plan.yearly : planPeriod === PlanPeriod.Yearly;

  return {
    isUpgrade: isPlanChangeUpgrade,
    defaultContractLength,
    isContacted,
    isYearlyButNotCurrent,
    nextBillingDate: plan.nextBillingDate,
    attributions: getAttributions(plan),
    attributionPrice: getAttributionPrice(plan.attributionPrice, plan.currency),
    basePrice: getBasePrice(plan.currency, plan.basePrice),
    features: enabledFeatures,
    changeType: getChangeType(plan, currentPlan),
    planName: plan.name,
  };
};

const mapDispatchToProps = {
  onCancel: hideForm,
  onConfirm: confirm,
  onSubmitToBeInTouch: submitToBeInTouch,
};

export const ChangePricingPlanFormContainer = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePricingPlanForm);
